import React, { Component } from 'react';

import membershipStore from '../../stores/membershipStore';
import { T } from '../../stores/textStore';


export default class extends Component {
	componentDidMount() {
		membershipStore.alerts.replace([]);
	}

	render() {				
		return (
			<div className="container py-5">
				<div className="row">
					<div className="col-md-12 text-center">
						<div className="alert alert-danger" role="alert">
							{T('An error has occurred.')}
						</div>					
						<p>
							{T('Sorry! We encountered an error while trying to process your membership change.')}
						</p>
						<p>
							{T('Please email care@kabbalah.com or call +1-888-898-8358 for assistance.')}
						</p>
					</div>
				</div>			  
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/views/membership/ErrorView.js